var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9288 3.55923C14.2772 1.9076 12.0804 1 9.74563 1C7.40769 1 5.21407 1.9076 3.56243 3.55923C1.9108 5.21086 1 7.40769 1 9.74242C1 14.4664 5.46742 18.3983 7.8695 20.5085C8.20304 20.8035 8.48847 21.0569 8.71937 21.2686C9.00801 21.538 9.37682 21.6727 9.74563 21.6727C10.1144 21.6727 10.4833 21.538 10.7687 21.2686C10.9996 21.0569 11.2882 20.8035 11.6218 20.5085C14.0206 18.3983 18.4881 14.4664 18.4881 9.74242C18.4881 7.40769 17.5805 5.21086 15.9288 3.55923Z",
    fill: "#39335D",
    stroke: "white",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1561 5.16177L5.57812 7.26666V14.3177H7.54011V11.3852H12.7721V14.3177H14.734V7.26666L10.1561 5.16177ZM9.50209 6.82352H10.8101V7.47519H9.50209V6.82352ZM12.7721 10.7335H7.54011V10.0819H12.7721V10.7335ZM12.7721 9.43019H7.54011V8.91211L7.67417 8.77852H12.638L12.7721 8.91211V9.43019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconN);
export default __webpack_public_path__ + "static/media/homeIconN.b25ff9d03630da0b45a6c7307d06b63c.svg";
export { ForwardRef as ReactComponent };